import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ArrowDown, ArrowUp } from "lucide-react";

export type SortDirection = "asc" | "desc";

interface TableSortProps {
  direction?: SortDirection;
  onChange?: (direction?: SortDirection) => void;
}

export const TableSort = ({ direction, onChange }: TableSortProps) => {
  const getIcon = () => {
    if (!direction) return <ArrowUp className="h-4 w-4" />;
    if (direction === "asc") return <ArrowUp className="h-4 w-4" />;
    return <ArrowDown className="h-4 w-4" />;
  };

  const handleClick = () => {
    if (!onChange) return;

    let nextDirection: SortDirection | undefined;
    if (!direction) {
      nextDirection = "asc";
    } else if (direction === "asc") {
      nextDirection = "desc";
    } else {
      nextDirection = undefined;
    }

    onChange(nextDirection);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleClick}
      className={cn("cursor-pointer h-8 w-8 p-0 opacity", {
        "opacity-0 hover:opacity-100": !direction,
      })}
    >
      {getIcon()}
    </Button>
  );
};
